var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;
import Vue from 'vue';
import Router from 'vue-router';
import Meta from 'vue-meta';
import firebase from 'firebase';
import Main from '@/components/Main.vue';
import CreateBOL from '@/components/CreateBOL.vue';
import EditBOL from '@/components/EditBOL.vue';
import DailyLogList from '@/components/DailyLogList.vue';
import ExternalCompanyInventory from '@/components/ExternalCompanyInventory.vue';
import ExternalLogList from '@/components/ExternalLogList.vue';
import ExternalInventory from '@/components/ExternalInventory.vue';
import Inventory from '@/components/Inventory.vue';
import WeightTotals from '@/components/WeightTotals.vue';
import Admin from '@/components/Admin.vue';
import PageNotFound from '@/components/404.vue';
import UnauthorizedPage from '@/components/401.vue';
import ErrorPage from '@/components/Error.vue';
import Auth from '@/components/Auth.vue';
import Login from '@/components/Login.vue';
import ResetPassword from '@/components/ResetPassword.vue';
import getUser from '@/services/user';
Vue.use(Router);
Vue.use(Meta);
var appRoutes = new Router({
    linkActiveClass: 'active',
    mode: 'history',
    routes: [
        {
            path: '/',
            component: Main,
            meta: { auth: true },
            children: [
                {
                    path: '',
                    name: 'Home Redirect'
                },
                {
                    path: 'create-bol',
                    name: 'Create BOL',
                    component: CreateBOL,
                    meta: { internal: true }
                },
                {
                    path: 'edit-bol/:id',
                    name: 'Edit BOL',
                    component: EditBOL,
                    meta: { internal: true }
                },
                {
                    path: 'daily-log-list',
                    name: 'Daily Log List',
                    component: DailyLogList,
                    meta: { internal: true }
                },
                {
                    path: 'external-company-inventory',
                    name: 'External Company Inventory',
                    component: ExternalCompanyInventory,
                    meta: { internal: true }
                },
                {
                    path: 'external-log-list',
                    name: 'External Log List',
                    component: ExternalLogList,
                    meta: { external: true }
                },
                {
                    path: 'external-inventory',
                    name: 'External Inventory',
                    component: ExternalInventory,
                    meta: { external: true }
                },
                {
                    path: 'inventory',
                    name: 'Inventory',
                    component: Inventory,
                    meta: { internal: true }
                },
                {
                    path: 'client-inventory',
                    name: 'External-Inventory',
                    meta: { external: true }
                },
                {
                    path: 'outbound-weight-total',
                    name: 'Outbound Weight Total',
                    component: WeightTotals,
                    meta: { internal: true }
                },
                {
                    path: 'inbound-weight-total',
                    name: 'Inbound Weight Total',
                    component: WeightTotals,
                    meta: { internal: true }
                },
                {
                    path: 'admin',
                    name: 'Admin',
                    component: Admin,
                    meta: { admin: true }
                },
                {
                    path: 'page-not-found',
                    name: '404',
                    component: PageNotFound
                },
                {
                    path: 'not-authorized',
                    name: '401',
                    component: UnauthorizedPage
                },
                {
                    path: 'error',
                    name: 'Error',
                    component: ErrorPage
                }
            ]
        },
        {
            path: '/auth',
            component: Auth,
            meta: { auth: false },
            children: [
                {
                    path: '',
                    alias: 'login',
                    name: 'Login',
                    component: Login
                },
                {
                    path: 'reset-password',
                    name: 'Reset Password',
                    component: ResetPassword
                }
            ]
        },
        {
            path: '*',
            redirect: '/page-not-found'
        }
    ]
});
appRoutes.beforeEach(function (to, from, next) { return __awaiter(_this, void 0, void 0, function () {
    var currentUser, requiresAuth, requiresAdmin, requiresInternal, requiresExternal, user, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                currentUser = firebase.auth().currentUser;
                requiresAuth = to.matched.some(function (record) { return record.meta.auth; });
                requiresAdmin = to.matched.some(function (record) { return record.meta.admin; });
                requiresInternal = to.matched.some(function (record) { return record.meta.internal; });
                requiresExternal = to.matched.some(function (record) { return record.meta.external; });
                if (!(requiresAuth && !currentUser)) return [3 /*break*/, 2];
                return [4 /*yield*/, next({ name: 'Login', query: { from: to.path } })];
            case 1:
                _a.sent();
                return [3 /*break*/, 23];
            case 2:
                if (!(!requiresAuth && currentUser)) return [3 /*break*/, 4];
                return [4 /*yield*/, next({ name: 'Home Redirect' })];
            case 3:
                _a.sent();
                return [3 /*break*/, 23];
            case 4:
                if (!(!requiresAuth && !currentUser)) return [3 /*break*/, 6];
                return [4 /*yield*/, next()];
            case 5:
                _a.sent();
                return [3 /*break*/, 23];
            case 6:
                _a.trys.push([6, 21, , 23]);
                return [4 /*yield*/, getUser()];
            case 7:
                user = _a.sent();
                if (!(to.name === 'Home Redirect')) return [3 /*break*/, 12];
                if (!(user.role === 'External User')) return [3 /*break*/, 9];
                return [4 /*yield*/, next({ name: 'External Log List' })];
            case 8:
                _a.sent();
                return [3 /*break*/, 11];
            case 9: return [4 /*yield*/, next({ name: 'Create BOL' })];
            case 10:
                _a.sent();
                _a.label = 11;
            case 11: return [3 /*break*/, 20];
            case 12:
                if (!(requiresAdmin && user.role !== 'Administrator')) return [3 /*break*/, 14];
                return [4 /*yield*/, next({ name: '401' })];
            case 13:
                _a.sent();
                return [3 /*break*/, 20];
            case 14:
                if (!(requiresInternal && (user.role !== 'Administrator' && user.role !== 'Internal User'))) return [3 /*break*/, 16];
                return [4 /*yield*/, next({ name: '401' })];
            case 15:
                _a.sent();
                return [3 /*break*/, 20];
            case 16:
                if (!(requiresExternal && user.role !== 'External User')) return [3 /*break*/, 18];
                return [4 /*yield*/, next({ name: '401' })];
            case 17:
                _a.sent();
                return [3 /*break*/, 20];
            case 18: return [4 /*yield*/, next()];
            case 19:
                _a.sent();
                _a.label = 20;
            case 20: return [3 /*break*/, 23];
            case 21:
                e_1 = _a.sent();
                console.log(e_1);
                return [4 /*yield*/, next({ name: 'Error' })];
            case 22:
                _a.sent();
                return [3 /*break*/, 23];
            case 23: return [2 /*return*/];
        }
    });
}); });
export default appRoutes;



//////////////////
// WEBPACK FOOTER
// ./src/router/index.ts
// module id = 156
// module chunks = 1